const iniState = {};
export const reducer=(state=iniState, action)=>{
    const {type, payload} = action 
    switch(type){
        default:return state
    }
}